<div class="card flex">
  <p-breadcrumb
    class="max-w-full flex-1"
    [model]="breadcrumbsItems"
    [home]="breadcrumbsHome"
  />
  <wiki-help [sectionId]="getWikiHelOverviewId()"></wiki-help>
  <tenant-notifications [category]="'ALL'"></tenant-notifications>
</div>
<div class="text-color text-3xl font-semibold leading-normal">
  {{ "common.entity." + entityType + ".overview.title" | translate }}
</div>
<div class="text-muted-color text-lg font-medium leading-normal">
  {{ "common.entity." + entityType + ".overview.subtitle" | translate }}
</div>

<simplified-table
  *ngIf="columnDefs"
  [isLoading]="isLoading"
  [dataItems]="allEntities"
  [tableSettings]="tableSettings"
  [columnDefs]="columnDefs"
  (rowAction)="onRowAction($event)"
  (tableAction)="onTableAction($event)"
>
</simplified-table>
<entity-info
  *ngIf="drawerSidebarVisible && selectedEntity && selectedEnvironmentUid"
  [preferencesGroups]="preferencesGroups"
  [dataItems]="dataItems"
  [environmentUid]="selectedEnvironmentUid"
  [sidebarOptions]="sidebarOptions"
  [entityType]="entityType"
  [(entity)]="selectedEntity"
  [(showDrawer)]="drawerSidebarVisible"
  (entityChange)="onEntityUpdated($event)"
>
</entity-info>
